import * as React from "react";
import { ActivityNavbar } from '../../../Shared/index';

interface NavBarProps {
  isOnMobile?: boolean;
  isTeacher?: boolean;
  language: string;
  languageOptions?: any;
  onTogglePreview?: () => void;
  previewShowing?: boolean;
  translate: (language: string) => string;
  updateLanguage: (language: string) => void;
}

export const NavBar: React.FC<NavBarProps> = (props) => (
  <ActivityNavbar
    checkTeacherIdentity={true}
    isELLDiagnostic={false}
    isOnMobile={props.isOnMobile}
    isTeacher={props.isTeacher}
    language={props.language}
    languageOptions={props.languageOptions}
    onTogglePreview={props.onTogglePreview}
    previewShowing={props.previewShowing}
    showLanguagePicker={true}
    showTeacherPreview={true}
    toolName="connect"
    translate={props.translate}
    updateLanguage={props.updateLanguage}
    useShowTranslationsCheck={true}
  />
);
